export default {
  LOADING: 'loading',
  SUCCESS: 'success',
  FAILED: 'failed',
  NONE: '',
};
